import type { Editor } from '@tiptap/react';

export const getTestId = (suffix: string, dataTestId: string | undefined) => (dataTestId ? `${dataTestId}-${suffix}` : suffix);

export const applyLink = (editor: Editor, href: string) => {
  const trimmed = href.trim();
  const chain = editor.chain().focus().extendMarkRange('link');
  (trimmed ? chain.setLink({ href: trimmed }) : chain.unsetLink()).run();
};
